import React, { useState, useEffect } from "react";
import Auction from "./Assets/Auction.png";
import { useCookies } from "react-cookie";
import { useToast } from "@chakra-ui/react";
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cookies, removeCookie] = useCookies(["email"]);
  const [check, setCheck] = useState(false);

  const toast = useToast();

  if (cookies.email) {
    var email = cookies.email; // get email from cookies
    // setCheck(true)
    // console.log(email,"email")
  }

  // Logout function  and delete cookies
  const handleDeleteCookie = () => {
    // removeCookie('email');

    document.cookie = "email=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; // delete cookies
    toast({
      title: "Logout Done.",
      status: "success",
      duration: 9000,
      isClosable: true,
      position: "top-right",
    });
  };

  // useEffect(()=>{
  //   var email = cookies.email;
  //       setCheck(true)
  //       console.log(email,"email")

  // },[check])

  return (
    <div>
      <div class="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div class="relative flex items-center justify-between">
          <a
            href="/"
            aria-label="Company"
            title="Company"
            class="inline-flex items-center"
          >
            <img src={Auction} class="w-9" />
            <span class="ml-2 text-xl font-bold tracking-wide text-gray-800 ">
              Malaktel Auction
            </span>
          </a>
          <ul class="flex items-center hidden space-x-8 lg:flex">
            <li className="transition duration-300 ease-in-out hover:scale-110">
              <a
                href="/"
                aria-label="Home"
                title="Home"
                class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                Home
              </a>
            </li>
            <li className="transition duration-300 ease-in-out hover:scale-110">
              <a
                href="/participate"
                aria-label="Participate in Auction"
                title="Participate in Auction"
                class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                Participate in Auction
              </a>
            </li>
            <li className="transition duration-300 ease-in-out hover:scale-110">
              <a
                href="/Register"
                aria-label="Register for Auctions"
                title="Register for Auctions"
                class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                Register for Auctions
              </a>
            </li>
            <li className="transition duration-300 ease-in-out hover:scale-110">
              <a
                href="/learnmore"
                aria-label="Guide"
                title="Guide"
                class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                Guide
              </a>
            </li>
          </ul>
          {!email ? (
            <ul class="flex items-center hidden space-x-8 lg:flex">
              <li>
                <a
                  href="/login"
                  class="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white bg-blue-500 rounded-md shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                  aria-label="Sign up"
                  title="Sign up"
                >
                  LOGIN / SIGN UP
                </a>
              </li>
            </ul>
          ) : (
            <>
              <ul class="flex items-center hidden space-x-8 lg:flex">
                <li>
                  <a
                    href="/"
                    class="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white bg-blue-500 rounded-md shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                    aria-label="Sign up"
                    title="Sign up"
                    onClick={handleDeleteCookie}
                  >
                    LOGOUT
                  </a>
                </li>
              </ul>
              {/* <h1>{email}</h1> */}
            </>
          )}
          <div class="lg:hidden">
            <button
              aria-label="Open Menu"
              title="Open Menu"
              class="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-deep-purple-50 focus:bg-deep-purple-50"
              onClick={() => setIsMenuOpen(true)}
            >
              <svg class="w-5 text-gray-600" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                />
                <path
                  fill="currentColor"
                  d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                />
                <path
                  fill="currentColor"
                  d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                />
              </svg>
            </button>
            {isMenuOpen && (
              <div class="absolute top-0 left-0 w-full z-50">
                <div class="p-5 bg-white border rounded shadow-sm">
                  <div class="flex items-center justify-between mb-4">
                    <div>
                      <a
                        href="/"
                        aria-label="Company"
                        title="Company"
                        class="inline-flex items-center"
                      >
                        <img src={Auction} class="w-9" />
                        <span class="ml-2 text-xl font-bold tracking-wide text-gray-800">
                          Malaktel Auction
                        </span>
                      </a>
                    </div>
                    <div>
                      <button
                        aria-label="Close Menu"
                        title="Close Menu"
                        class="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <svg class="w-5 text-gray-600" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <nav>
                    <ul class="space-y-4">
                      <li>
                        <a
                          href="/"
                          aria-label="Home"
                          title="Home"
                          class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Home
                        </a>
                      </li>
                      <li>
                        <a
                          href="/participate"
                          aria-label="Participate in Auction"
                          title="Participate in Auction"
                          class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Participate in Auction
                        </a>
                      </li>
                      <li>
                        <a
                          href="/Register"
                          aria-label="Register for Auctions"
                          title="Register for Auctions"
                          class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Register for Auctions
                        </a>
                      </li>
                      <li>
                        <a
                          href="/learnmore"
                          aria-label="Guide"
                          title="Guide"
                          class="font-medium tracking-wide  transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Guide
                        </a>
                      </li>
                      {!email ? (
                        <li>
                          <a
                            href="/login"
                            class="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                            aria-label="Sign up"
                            title="Sign up"
                          >
                            LOGIN / SIGN UP
                          </a>
                        </li>
                      ) : (
                        <li>
                          <a
                            href="/login"
                            class="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                            aria-label="Sign up"
                            title="Sign up"
                            onClick={handleDeleteCookie}
                          >
                            LOGOUT
                          </a>
                        </li>
                      )}
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
